import { render } from "./promotionalSelectModel.vue?vue&type=template&id=38781742"
import script from "./promotionalSelectModel.vue?vue&type=script&lang=js"
export * from "./promotionalSelectModel.vue?vue&type=script&lang=js"

import "./promotionalSelectModel.vue?vue&type=style&index=0&id=38781742&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__